export const CUSTOM_STYLE_PREFIX_COLOR = 'CUSTOM_COLOR_';
